import { createAction } from 'redux-actions';

export const FETCHED_SERVICES = 'FETCHED_SERVICES';

export const fetchedServices = createAction(FETCHED_SERVICES, data => data);
